import { useEffect, useState } from 'react';
import { useApi } from '@backstage/core-plugin-api';
import { stringifyEntityRef } from '@backstage/catalog-model';
import { useEntity } from '@backstage/plugin-catalog-react';
import { scoreCardApiRef } from '../api';



export type SecurityScoreResponse = {
  date: string;
  repository: string;
  codeql_alerts: number;
  dependabot_alerts: number;
  security_score: number;
  checks: string[] ;
};

export const useSecurityScore = () => {
  const [score, setScore] = useState<number>(0);
  const [date, setDate] = useState<string>('');
  const [checks, setChecks] = useState<string[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const { entity } = useEntity();
  const entityRef = stringifyEntityRef(entity);
  const api = useApi(scoreCardApiRef);

  useEffect(() => {
    setLoading(true);
    api
      .getSecurityScore(entityRef)
      .then((res: SecurityScoreResponse) => {
 
        setScore(res.security_score ?? 0);
        setDate(res.date ?? '');
        setChecks(res.checks ?? []);
        setError(null);
      })
      .catch((err: Error) => setError(err.message))
      .finally(() => setLoading(false));
  }, [entityRef, api]);

  return { score, date, checks, loading, error };
};
